module.exports = __webpack_public_path__ + "static/media/select-crop.69d3405c.png";